import { useMutation } from '@tanstack/react-query';
import { gaService } from 'services/ga';
import { useSetPassword, useUpdateProfile } from 'shared/data/webApp/v1';
import { saveQualificationQuestionsAnswers } from 'shared/helpers';

import { prepareQualificationQuestions } from '../../../../resources/helpers';
import { FirstStartProfileData } from '../../../../resources/types';
import { UseProfileSetupParams } from './useProfileSetup.types';

export const useProfileSetup = (params: UseProfileSetupParams) => {
    const { profileData, onGoToNextStep, onSetQualificationQuestionsAnswers, disableNotifications } = params;

    const { mutateAsync: updateProfile } = useUpdateProfile();
    const { mutateAsync: setPassword } = useSetPassword();

    const setupProfile = async (data: FirstStartProfileData) => {
        const qualificationQuestionAnswers = prepareQualificationQuestions(data);

        await updateProfile({
            body: {
                firstName: profileData.firstName,
                lastName: profileData.lastName,
                skype: '',
                phone: profileData.phone || '',
                timeZoneForEmail: window.ApprovalMax.userTimeZone,
                qualificationQuestionAnswers: qualificationQuestionAnswers ?? undefined,
                sendApprovalChangeNotifications: disableNotifications ? false : undefined,
                sendNewRequestsNotifications: disableNotifications ? false : undefined,
                sendCommentsNotifications: disableNotifications ? false : undefined,
                sendWorkflowNotifications: disableNotifications ? false : undefined,
                sendSummaryNotifications: disableNotifications ? false : undefined,
            },
        });

        await setPassword({
            body: {
                timeZoneForEmail: window.ApprovalMax.userTimeZone,
                pwd: profileData.password,
            },
        });

        saveQualificationQuestionsAnswers(qualificationQuestionAnswers);

        onSetQualificationQuestionsAnswers(qualificationQuestionAnswers);
    };

    return useMutation(setupProfile, {
        onSuccess: () => {
            gaService.sendEvent('trial_sign_up', {
                send_to: ['AW-458300955/fEplCOncsqYaEJu8xNoB', 'default'],
            });

            onGoToNextStep();
        },
    });
};
